import React from "react"
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom"
import Login from "./presentation/pages/Login"
import MemberDashboard from "./presentation/pages/MemberDashboard"
import Terminal from "presentation/pages/Terminal"
import ProductDashboard from "presentation/pages/ProductManagement"
import "bootstrap/dist/css/bootstrap.min.css"
import Dashboard from "./presentation/pages/Dashboard"
import ChangePassword from "presentation/pages/ChangePassword"
import { AuthProvider } from "presentation/context/AuthContext"
import ProtectedLayout from "presentation/components/ProtectedLayout"
import OrderDashboard from "presentation/pages/OrderManagement"
import MyAccountPage from "presentation/pages/MyAccountPage"

/**
 * App component that manages routing, using AuthProvider to manage authentication state
 * and ProtectedLayout to group protected routes.
 */
const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Route: Login Page */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes: Grouped under ProtectedLayout */}
          <Route element={<ProtectedLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/orders" element={<OrderDashboard />} />
            <Route path="/members" element={<MemberDashboard />} />
            <Route path="/terminal/:terminalId" element={<Terminal />} />
            <Route path="/products" element={<ProductDashboard />} />
            <Route path="/my-account" element={<MyAccountPage />} />
          </Route>
          <Route path="/change-password" element={<ChangePassword />} />
          {/* Catch-all Route: Redirect to login if route not found */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App